import type { AvailableExam, AvailableMarker } from "@/types/exam"
import { HttpClient, STATIC_ROOT } from "@/api/httpClient"

export default {
	list() {
		return HttpClient.get<AvailableExam[]>(`${STATIC_ROOT}/exams`)
	},
	markers() {
		return HttpClient.get<AvailableMarker[]>(`${STATIC_ROOT}/exams/laboratory-markers`)
	}
}
